$(document).on 'turbolinks:load', ->
  $('textarea.mark-it-zero').each (idx) ->
    if !$('.editor-toolbar')[idx]
      new Editor(
        element: $('textarea.mark-it-zero')[idx]
      )

